import * as angular from 'angular';
import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state, CorporateSettingsService, DestructiveOperationModal) {
        this.$state = $state;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.credentials = angular.copy(this.resolve.credentials);
    }

    submit() {
        const ipFilter = this.credentials.ipFilter.trim();
        const companyId = this.$state.params.companyId;

        
            this.CorporateSettingsService
                .setIpFilter(companyId, ipFilter)
                .then(() => this.close({$value: this.credentials}))
                .catch(() => {
                    const key = 'ip_address_filter.message.invalid';
                    this.spAlert = new SpAlert('danger', key);
                });
        
    }

    notModified() {
        return this.credentials.ipFilter === this.resolve.credentials.ipFilter;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/edit-ip-address-filter/edit-ip-address-filter.controller.js